import { enhanceEndpoints } from '../core';
// Moved to the types package so apps/main can import it too.
export type { GlobalSettingsConfig } from '@consolidocs-ui/types';
export { defaultGeneralConfiguration } from '@consolidocs-ui/types';

interface GeneralConfigurationResponse {
  status?: string;
  data?: {
    id: string;
    name: string;
    configuration: Record<string, any>;
    created_at: string;
    updated_at: string;
  };
  // Alternative response structure in case API returns data differently
  id?: string;
  name?: string;
  configuration?: Record<string, any>;
  created_at?: string;
  updated_at?: string;
}



const GlobalSettingsApiWithTag = enhanceEndpoints({
  addTagTypes: ['global-settings'],
});

// Global Settings API Services
export const GlobalSettingsApi = GlobalSettingsApiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getGeneralConfiguration: builder.query<GeneralConfigurationResponse, string>({
      query: (name) => ({
        url: 'general-configuration-detail/',
        params: {
          name,
        },
      }),
      providesTags: ['global-settings'],
    }),

    updateGeneralConfiguration: builder.mutation<
      GeneralConfigurationResponse,
      { name: string; configuration: Record<string, any> }
    >({
      query: ({ name, configuration }) => ({
        url: 'general-configuration/',
        method: 'POST',
        data: {
          name,
          configuration,
        },
      }),
      invalidatesTags: ['global-settings'],
    }),
  }),
});

export const {
  useLazyGetGeneralConfigurationQuery,
  useUpdateGeneralConfigurationMutation,
} = GlobalSettingsApi;